/**
 * Copyright 2009-2018, Figure (http://www.commercebyfigure.com)
 *
 * Licensed under The BSD License
 * Redistributions of files must retain the above copyright notice.
 *
 * @copyright    Copyright 2009-2018, Figure (http://www.commercebyfigure.com)
 * @package      Figure - Cart
 * @author       Ian Tucker <ian at commercebyfigure.com>
 * @license      BSD License (http://www.opensource.org/licenses/bsd-license.php)
 */

const page = window.location.pathname.split("/")[1];

$(document).ready(function () {
	$("a.add-cart-modal").bind("click", addCart);
	$(".product-order").bind("click", addCart);
	$(".btn-add-cart").bind("click", addCart);

	$(".btn-add-on-cart").bind("click", addOnCart);

	$(".btn-add-club").on("click", addClub);

	$("#shipping_insurance").bind("change", toggleInsurance);

	//NOTE: tokenizeCard comes from the payment-form(|-no-zip|-se).st.js file that
	// FigureBaseCart's _snippets/javascript-payment includes (with the latter's just being an empty function)
	$("#credit-card-form").bind("submit", tokenizeCard);
//$("#shipping_methods").on('change', 'input:radio.shipping_method', updateShipping);

	// Auto-save Requested Ship Date
	$("input[type=radio][name='data[requested_ship_date]']").bind("change", updateRequestedShipDate);
	selectFirstRadioOption("data[requested_ship_date]");

	//legacy; remove once all client overrides are updated to use name="data[requested_ship_date]"
	$("input[type=radio][name=requested_ship_date]").bind("change", updateRequestedShipDate);
	selectFirstRadioOption("requested_ship_date");

	// Auto-save order comments (instructions & gift message)
	$("#js-instructions, #js-gift_message").on("blur", updateComments);

	$("#credit-card-form #state").bind("change", internationalShippingSelect);

	// Purchase Quantity Selector
	$(".qty").on("change", function () {
		const $this = $(this);
		const parts = $this.attr("id").split("qty-");
		const id = parts[1];
		const val = $this.val();

		updateQuantity(id, val);
		checkWishRequests(id, val);
	});

	// Wish Quantity Selector
	$(".wish-qty").bind("change", function () {
		const $this = $(this);
		const parts = $this.attr("id").split("qty-");
		const id = parts[1];
		const val = $this.val();

		updateWishQuantity(id, val);
	});

	$("a.launch-modal").bind("click", launchModal);
	$("input:radio.launch-modal").bind("change", launchModalSelect);
	$("select.launch-modal").bind("change", launchModalSelect);

	/**
	 * Click Handler for /offering/checkout
	 * Appends Spinner to body and disabled button
	 * to prevent duplicate order
	 *
	 * Last Edit: 9/01/2020
	 *
	 * @author Victor Ragojos
	 */
	$("#button-place-order").on("mousedown", function (e) {
		e.stopPropagation();

		$(this).attr("disabled", true);
		const modal = $('<div id="checkoutSpinnerModal"></div>');
		modal.addClass("fade");
		modal.addClass("modal");
		modal.attr("keyboard", false);
		modal.attr("data-backdrop", "static");
		const dialog = $('<div class="modal-dialog modal-dialog-centered"></div>');

		const content = $('<div class="modal-content d-flex"></div>');
		content.addClass("align-items-center");
		const body = $('<div class="modal-body d-flex"></div>');
		const spinner = $('<div class="spinner-border text-primary"></div>');

		body.append(spinner);

		content.append(body);
		dialog.append(content);
		modal.append(dialog);

		content.css({
			border: "none",
			backgroundColor: "transparent",
		});

		spinner.css({
			zIndex: 9999,
		});

		$("body").append(modal);
		modal.modal("show");

		$("#cartForm").submit();
	});

	// prevent rage-click multi-submission of form
	$("form").bind("submit", function (e) {
		const $form = $(this);
		if ($form.data("submitted") === true) {
			// Previously submitted - don't submit again
			e.preventDefault();
		} else {
			// Mark it so that the next submit can be ignored
			$form.data("submitted", true);
		}
	});
});

function addCart(event) {
	const $this = $(this);
	if (
		$this.hasClass("add-to-added")
		&& $this.text().includes('Add')
		&& !$this.text().includes('Added')
	) {
		$this.text('Added');
	}

	// Everything after /add/
	let $parts = $this.attr("href").split("/add/");

	// Break up by forward slash (/)
	$parts = $parts[1].split("/");

	// First Argument is SKU
	const $sku = $parts[0];
	const $quant = $this.closest("form").find("select").val() || 1;

	//const modalSize = 'small-modal';
	//$('.site-mask').fadeIn();
	//$('.site-modal').attr('class', 'site-modal '+modalSize);
	//$('body').addClass('modal-open').addClass('modal-on-page');
	//$('.site-modal').removeAttr('aria-hidden').attr('tab-index','1');
	const $cartModal = $("#cartModal");
	$cartModal.modal();
	$cartModal.find(".modal-load-area").html("").removeClass("loaded");
	$.getJSON(`/cart/add_modal/${$sku}/${$quant}.json`, function (data) {
		const { product } = data;
		$cartModal.find(".modal-load-area").html(data.html).addClass("loaded");
		const $face = $(".face");
		const $cartcount = $("#cartcount");
		if (data.quantity > 0) {
			// NOTE: For analytics since `preventDefault` prevents other `click` event listeners from being triggered
			try {
				fbq("track", "AddToCart", {
					"currency": "USD",
					"value": data.total.subtotal,
					"contents": [{ id: product.sku, name: product.name, quantity: data.quantity }]
				});

				const formatter = new Intl.NumberFormat('en-US', {
					currency: "USD",
					style: "currency",
				});

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({ ecommerce: null });
				window.dataLayer.push({
					event: "add_to_cart",
					ecommerce: {
						"currency": "USD",
						"value": data.total.subtotal,
						"items": [{
							item_id: product.sku,
							item_name: product.name,
							item_brand: product.producer,
							item_category: product.country,
							item_category2: product.region,
							item_category3: product.producer,
							item_variant: product.blends,
							price: formatter.format(product.price),
							quantity: data.quantity,
						}],
					},
				});
			} catch(e) {}

			$cartcount.html(` <span class='badge badge-pill badge-primary'>${data.quantity}</span>`);
			$(".cart-link").removeClass("hide-cart");
			$face.addClass("happy");

			// Check if klaviyo instance is available
			// in global window object
			if (!!window._learnq) {
				klaviyoAddCart(data);
			}
		}
		else {
			$cartcount.html("");
			$face.removeClass("happy");
		}
		$face.addClass("show");
	});
	event.preventDefault();
	return false;
}

function addClub() {
	const data = $(this).data();
	console.log(data);
	klaviyoAddClub(data);
}

// Add a Thousand Separator to a numeric string
function addCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function addOnCart(event) {
	const $this = $(this);

	// Everything after /add/
	let $parts = $this.attr("href").split("/add/");

	// Break up by forward slash (/)
	$parts = $parts[1].split("/");

	// First Argument is SKU
	const $sku = $parts[0];
	const $quant = $this.closest("form").find("select").val() || 1;

	//const modalSize = 'small-modal';
	//$('.site-mask').fadeIn();
	//$('.site-modal').attr('class', 'site-modal '+modalSize);
	//$('body').addClass('modal-open').addClass('modal-on-page');
	//$('.site-modal').removeAttr('aria-hidden').attr('tab-index','1');
	const $cartModal = $("#cartModal");
	$cartModal.modal();
	$cartModal.find(".modal-load-area").html("").removeClass("loaded");
	$.getJSON(`/purchase/add_modal/${$sku}/${$quant}.json`, function (data) {
		$cartModal.find(".modal-load-area").html(data.html).addClass("loaded");
		const $face = $(".face");
		const $cartcount = $("#cartcount");
		if (data.quantity > 0) {
			$cartcount.html(` <span class='badge badge-pill badge-primary'>${data.quantity}</span>`);
			$(".cart-link").removeClass("hide-cart");
			$face.addClass("happy");

			// Check if klaviyo instance is available
			// in global window object
			if (!!window._learnq) {
				klaviyoAddCart(data);
			}
		}
		else {
			$cartcount.html("");
			$face.removeClass("happy");
		}
		$face.addClass("show");
	});
	event.preventDefault();
	return false;
}

function checkWishRequests(id, quant) {
	const max = parseInt($(`#qty-${id} option:last-child`).val());
	quant = parseInt(quant);
	const $wishwrapper = $(`.wishwrapper-${id}`);
	const $wishqty = $(`#wishqty-${id}`);
	if (quant === max) {
		$wishwrapper.show();
	}
	else if (quant < max) {
		$wishwrapper.hide();
		$wishqty.val($wishqty.find("option:first").val());
		updateWishQuantity(id, 0);
	}
}

function formatProductName(product) {
	return `${product.name} ${product.subtitle}`;
}

function internationalShippingSelect() {
	if ($(this).val() === "Int") {
		$("#state_select_field").html(
			`<input type="text" size="10" name="data[state]" value="" placeholder="International..." />`
		);
	}
}

function klaviyoAddCart(payload) {
	const { url, cart, total, product, quantity } = payload;
	if (
		!Array.isArray(cart)
		|| typeof url !== "string"
		|| typeof total !== "object"
		|| typeof product !== "object"
	) {
		return;
	}

	const { subtotal } = total;

	const cats = [];
	if (typeof product.categories === "object") {
		Object.keys(product.categories).forEach((k) => {
			const c = product.categories[k];
			cats.push(c.name);
		});
	}

	const prodURL = `${url}/product/detail/${product.sku}/`;
	const coURL = `${url}/cart/`;
	window._learnq.push([
		"track",
		"Added to Cart",
		{
			$value: subtotal,
			AddedItemProductName: formatProductName(product),
			AddedItemProductID: product.id,
			AddedItemSKU: product.sku,
			AddedItemCategories: cats,
			AddedItemImageURL: product.image,
			AddedItemURL: prodURL,
			AddedItemPrice: product.price,
			AddedItemQuantity: quantity,
			ItemNames: cart.map((p) => formatProductName(p)),
			CheckoutURL: coURL,
			Items: cart.map((p) => ({
				ProductID: p.id,
				SKU: p.sku,
				ProductName: formatProductName(p),
				Quantity: quantity,
				ItemPrice: p.price,
				RowTotal: p.price * quantity,
				ProductURL: prodURL,
				ImageURL: p.image || "",
				ProductCategories: (
					typeof p.categories === "object"
					&& Object.keys(p.categories).map((k) => {
						return p.categories[k].name;
					})
				) || [],
			})),
		},
	]);
}

function klaviyoAddClub(data) {
	const { id = "", sku = "", url = "", name = "", image = "" } = data;
	window._learnq.push([
		"track",
		"Added to Cart (Club)",
		{
			$value: 1.0,
			AddedItemProductName: name,
			AddedItemProductID: id,
			AddedItemSKU: id,
			AddedItemCategories: ["Club"],
			AddedItemImageURL: url,
			AddedItemURL: url,
			AddedItemPrice: 1.0,
			AddedItemQuantity: 1,
			ItemNames: [name],
			CheckoutURL: url,
			Items: [
				{
					ProductID: id,
					SKU: id,
					ProductName: name,
					Quantity: 1,
					ItemPrice: 1.0,
					RowTotal: 1.0,
					ProductURL: `${url}${sku}`,
					ImageURL: image,
					ProductCategories: ["Club"],
				},
			],
		},
	]);
}

// Launch modal from Link
function launchModal($event) {
	const $href = $(this).attr("href").split("#");
	const $url = $href[0];
	const $id = $href[1];

	$event.preventDefault();

	const $idTarget = $("#" + $id);
	if ($url.length > 0) {
		$.get($url, function ($data) {
			$idTarget.html($data);
			$idTarget.modal({ backdrop: "static" });
		});
	}
	else {
		$idTarget.modal({ backdrop: "static" });
	}
}

// Launch modal from Select
function launchModalSelect($event) {
	const href = $(this).val().split("#");
	const url = href[0];
	const id = href[1];
	const $id = $("#" + id);

	$event.preventDefault();

	if (url.length === 0) {
		$id.modal({ backdrop: "static" });
	}
	else if (id === undefined || id.length === 0) {
		window.location = url;
	}
	else {
		$.get(url, function ($data) {
			$id.html($data);
			$id.modal({ backdrop: "static" });
		});
	}
}

// If no radio option is selected, select the first one
function selectFirstRadioOption(name) {
	const $radio = $(`input[type=radio][name='${name}']`);
	if ($radio.length > 0) {
		if (!$radio.filter(":checked").length) {
			$radio[0].checked = true;
		}
	}
}

// Toggle Insurance
function toggleInsurance() {
	const insurance = $("#shipping_insurance").is(":checked") ? 1 : 0;

	$.getJSON(
		`/${page}/update_insurance/${insurance}/`,
		function (data) {
			const {
				shipping,
				shipping_insurance,
				tax,
				total,
			} = data;

			updateDisplay(
				".js-shipping_display, #shipping_display, #shipping_display_alt",
				parseFloat(shipping).toFixed(2)
			);

			updateDisplay(
				".js-shipping_insurance_display, #shipping_insurance_display",
				shipping_insurance.toFixed(2),
				true
			);

			updateDisplay(".js-tax_display, #tax_display", parseFloat(tax).toFixed(2));

			updateDisplay(
				".js-total_display, #total_display, #total_display_alt, #total_display_top",
				parseFloat(total).toFixed(2)
			);
		}
	);
}

function updateComments() {
	const instructions = $("#js-instructions").val() || "";
	const giftMessage = $("#js-gift_message").val() || "";

	$.getJSON(
		`/${page}/update_comments/`,
		{
			instructions: instructions,
			gift_message: giftMessage,
		},
		function (data) {}
	);
}

/**
 * Makes an ajax call to cart/get_items and updates #Price_(sku) & #Vol_(sku) for each item in the cart.
 *
 * Called by updateQuantity if $product['enable_product_volume_discounts'] == 'TRUE' on cart/index,
 * and therefore it added an input#enable_product_volume_discounts with value = 'TRUE' to the page.
 */
function updateDiscountPrice() {
	$.getJSON("/cart/get_items", function (data) {
		$.each(data, function (i, item) {
			const { price, has_volume_discount, sku } = item;

			$(`#Price_${sku}`).html(price);

			const $theVolID = $(`#Vol_${sku}`);
			if (Number(has_volume_discount) === 1) {
				$theVolID.fadeIn();
			} else {
				$theVolID.fadeOut();
			}
		});
	});
}

/**
 * Update Display
 *
 * @param  selector       string  id's & classes to update with the provided value
 * @param  value          string  numeric string of the value in question
 * @param  hideRowIfZero  bool    if true, hide the (monetary) field row if zero, otherwise show it
 */
function updateDisplay(selector, value, hideRowIfZero = false) {
	const $displayField = $(selector);

	if ($displayField.length) {
		if (value > 0) {
			value = addCommas(value);
			$displayField.html(value);
			if (hideRowIfZero) {
				$displayField.closest("tr").show();
			}
		}
		else {
			$displayField.html(value === "0.00" ? "0.00" : "0");
			if (hideRowIfZero) {
				$displayField.closest("tr").hide();
			}
		}
	}
}

// Updates quantity in cart
function updateQuantity(id, value) {
	if (value <= 0) {
		value = "0";
	}

	$.getJSON(
		`/${page}/update_quantity/${id}/${value}/`,
		function (data) {
			const {
				quantity,
				subtotal,
				shipping,
				discount,
				tax,
				total,
				crv,
				ca_redemption_value,
				co_retail_delivery_fee,
				me_bottle_deposit,
				credits,
				adjusted_subtotal,
				shipping_insurance,
				tip,
				allocation_remaining,
				expires,
			} = data;

			updateDisplay(".js-item_count_display, #item_count_display", quantity);

			updateDisplay(
				".js-subtotal_display, #subtotal_display, #subtotal_display_2",
				subtotal.toFixed(2)
			);

			updateDisplay(
				".js-shipping_display, #shipping_display, #shipping_display_alt",
				shipping.toFixed(2)
			);

			// CA redemption value (CRV)
			const crvAmount = ca_redemption_value || crv;
			updateDisplay(
				".js-ca_redemption_value_display, #ca_redemption_value_display, #crv_display",
				crvAmount.toFixed(2),
				true
			);

			updateDisplay(
				".js-co_retail_delivery_fee_display, #co_retail_delivery_fee_display",
				co_retail_delivery_fee.toFixed(2),
				true
			);

			updateDisplay(
				".js-me_bottle_deposit_display, #me_bottle_deposit_display",
				me_bottle_deposit.toFixed(2),
				true
			);

			updateDisplay(".js-discount_display, #discount_display", discount.toFixed(2));

			updateDisplay(".js-credits_display, #credits_display", credits.toFixed(2), true);

			// Adjusted subtotal - only show if different from subtotal
			const $adjustedSubtotalDisplay = $(".js-adjusted_subtotal_display, #adjusted_subtotal_display");
			if (adjusted_subtotal !== undefined && adjusted_subtotal !== subtotal) {
				updateDisplay($adjustedSubtotalDisplay, adjusted_subtotal.toFixed(2));
				$adjustedSubtotalDisplay.closest("tr").show();
			}
			else {
				$adjustedSubtotalDisplay.closest("tr").hide();
			}

			updateDisplay(".js-tax_display, #tax_display", tax.toFixed(2));

			updateDisplay(
				".js-shipping_insurance_display, #shipping_insurance_display",
				shipping_insurance.toFixed(2),
				true
			);

			updateDisplay(".js-tip_display, #tip_display", tip.toFixed(2), true);

			updateDisplay(
				".js-total_display, #total_display, #total_display_alt, #total_display_top",
				total.toFixed(2)
			);

			const $addYourFullAllocation = $(".add-your-full-allocation");
			if ($addYourFullAllocation.length) {
				console.log(allocation_remaining);
				if (allocation_remaining === true) {
					console.log("you have more to add");
				$addYourFullAllocation.show();
        }
				else {
					console.log("you have NO more to add");
				$addYourFullAllocation.hide();
				}
			}

			const $cartcount = $("#cartcount");
			const $cartcountnav = $("#cartcountnav");
			const $cartLink = $(".cart-link");
			if (quantity > 0) {
				$cartcount.html(`<span class='badge badge-pill badge-primary'>${quantity}</span>`);
				$cartcountnav.html(`<span class='badge badge-pill badge-primary'>${quantity}</span>`);
				$cartLink.removeClass("hide-cart");
			}
			else {
			$cartcount.html("");
			$cartcountnav.html("");
			$cartLink.addClass("hide-cart");
			}

			if (expires > 0) {
				const totalSecs = expires;
				const secondz = totalSecs * 1000;
				console.log(totalSecs);
				if (secondz > 0) {
					window.setTimeout(function () {
						location.href = "/offering/expired/";
					}, secondz);
				}
			}

			const $shippingOfferMin = $("#shipping-offer-min");
			if ($shippingOfferMin.length) {
				//TODO: this function doesn't appear to exist!!!
				swapAddBottleText(parseInt($shippingOfferMin.val()), parseInt(quantity));
			}

			const $cartShippingMessage = $(".cart-shipping-message");
			const $moreBottles = $(".more-bottles");
			const $qualified = $(".qualified");
			if (quantity < 6) {
				$cartShippingMessage.removeClass("blank");
				$moreBottles.removeClass("no-more");
				$("#moar").html(6 - quantity);
				$qualified.removeClass("success");

				//plural must be in relation to #moar above, so 6 - 5 = 1...
				if (parseInt(quantity) === 5) {
					$("#plural").hide();
			}
			else {
					$("#plural").show();
				}
			}
			else {
				$cartShippingMessage.removeClass("blank");
				$moreBottles.addClass("no-more");
				$qualified.addClass("success");
			}

			$("#secure-checkout-update-cart").hide();
		}
	).done(function () {
		const isDiscounted = $("#enable_product_volume_discounts").val();
		if (isDiscounted === "TRUE") {
			updateDiscountPrice();
		}
	});
}

function updateRequestedShipDate() {
	$.getJSON(`/${page}/select-requested-ship-date/${$(this).val()}/`, function (data) {});
}

// Update Shipping Method -- event handler is currently commented out
// function updateShipping() {
//   const fields = [
//     "first_name",
//     "last_name",
//     "company",
//     "address",
//     "address_2",
//     "city",
//     "state",
//     "zip",
//     "phone",
//   ];
//   const ship_method = $("input:radio.shipping_method:checked");
//
//   // Not Pickup
//   if (!ship_method.hasClass("pickup")) {
//     $.each(fields, function (key, value) {
//       const $value = $(`#${value}`);
//       $value.val("");
//       $value.removeAttr("disabled");
//     });
//     $("#address-form-container").removeClass("hidden");
//     $("#shipping-method-description").addClass("hidden");
//     $("#shipping-address-form").attr("action", "/cart/add-address.html");
//     $.getJSON(`/${page}/update_shipping_method/${ship_method.val()}.json`, function (data) {});
//     return;
//   }
//
//   // Pickup Address
//   $.getJSON(`/${page}/update_shipping_method/${ship_method.val()}.json`, function (data) {
//     data = data.shipment.address;
//     $.each(fields, function (key, value) {
//       const $value = $(`#${value}`);
//       $value.attr("disabled", "disabled");
//       $value.val(data[value]);
//     });
//     const $shippingMethodDescription = $("#shipping-method-description");
//     const description = $(`#shipping-method-message-${ship_method.val()}`).html();
//     if (description) {
//       $shippingMethodDescription.html(description);
//       $shippingMethodDescription.removeClass("hidden");
//     }
// else {
//       $shippingMethodDescription.addClass("hidden");
//     }
//     $("#address-form-container").addClass("hidden");
//     $("#shipping-address-form").attr("action", "/cart/checkout.html");
//   });
// }

// Updates quantity in wishlist
function updateWishQuantity(id, value) {
	if (value < 0) {
		value = 0;
	}
	$.getJSON(`/offering/update_wishlist/${id}/${value}/`, function (data) {});
}
